import React from "react";
import "./DeliveryTracker.css";

const DeliveryTracker = ({ statusData, stepMap, moduleName }) => {
    // Define all steps and their corresponding backend keys


    // Create full steps array (even if dates are null)
    const steps = (() => {
        const isEStore = moduleName === 'EStore';

        const allSteps = isEStore
            ? [
                { key: "BookingDate", label: "Booked" },
                { key: "ConfirmedDate", label: "Confirmed" },
                { key: "ProcessingDate", label: "Processed" },
                { key: "OnTheWayDate", label: "En-Route" },
                { key: "DeliveredDate", label: "Delivered" },
            ]
            : [
                { key: "BookingDate", label: "Processed" },
                { key: "ConfirmedDate", label: "Confirmed" },
                { key: "CompletedDate", label: "Completed" },
            ];

        // Handle Cancelled
        if (statusData.CancelledDate) {
            return [
                {
                    key: "processed",
                    label: " Processed",
                    date: statusData.BookingDate || null
                },
                {
                    key: "cancelled",
                    label: " Cancelled",
                    date: statusData.CancelledDate
                }
            ];
        }

        // Handle Rejected
        if (statusData.RejectedDate) {
            return [
                {
                    key: "processed",
                    label: " Processed",
                    date: statusData.BookingDate || null
                },
                {
                    key: "rejected",
                    label: " Rejected",
                    date: statusData.RejectedDate
                }
            ];
        }

        // Default flow: map all steps
        return allSteps.map(({ key, label }) => ({
            key: label.toLowerCase(),
            label: ` ${label}`,
            date: statusData[key] || null
        }));
    })();




    // Find the current step index (last step that has a date)
    const currentIndex = steps?.reduce((lastIdx, step, idx) => {
        return step?.date ? idx : lastIdx;
    }, -1);

    return (
        <div className="tracker-wrapper">
            <h5 className="card-title text-center mb-2 fw-bold">Order Status</h5>
            <div className={`${moduleName === 'EStore' ? 'stepper-product' : 'stepper'}`}  >
                {steps.map((step, index) => {
                    const isCompleted = index <= currentIndex;
                    const isLineActive = index < currentIndex;

                    return (
                        <div key={step.key} className="step-item">
                            <div className={`step-icon ${isCompleted ? "active" : ""}`}>
                                {isCompleted ? "✔" : ""}
                            </div>
                            <div className={`step-label ${isCompleted ? "active" : ""}`}>
                                <span>{step.label}</span> <br />
                                <span style={{ fontSize: "10px" }}>
                                    {step.date || "Pending"}
                                </span>
                            </div>
                            {index < steps.length - 1 && (
                                <div
                                    className={`${moduleName === 'EStore' ? ' step-line-custom-product' : 'step-line-custom'} width-custom ${isLineActive ? "active" : ""}`}
                                    style={{ right: "-50%", left: "50%" }}
                                />
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default DeliveryTracker;
